module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      unread: !_vm.bericht.gelezen
    }
  }, [_c('div', {
    staticClass: "card-header",
    class: {
      open: _vm.bericht.isOpen
    },
    on: {
      "click": function($event) {
        _vm.setUpdate(_vm.bericht.id, _vm.bericht.type, 'gelezen');
        _vm.bericht.isOpen = !_vm.bericht.isOpen
      }
    }
  }, [_c('a', {
    staticClass: "preventdefault",
    attrs: {
      "href": "#"
    }
  }, [_c('span', {
    staticClass: "date"
  }, [_vm._v(_vm._s(_vm.bericht.datumText))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.bericht.onderwerp))])])]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "card-block"
  }, [(_vm.bericht.verzonden === false) ? _c('p', {
    staticClass: "restylecontent",
    domProps: {
      "innerHTML": _vm._s(_vm.bericht.inhoud)
    }
  }) : _c('p', {
    staticClass: "restylecontent"
  }, [_vm._v(_vm._s(_vm.bericht.inhoud))]), _vm._v(" "), _c('ul', {
    staticClass: "buttonbar",
    class: {
      archive: _vm.bericht.archief
    }
  }, [(_vm.bericht.verzonden === false && _vm.bericht.type != 'MELDING' && _vm.bericht.iframeReageerOpBerichtUrl != '') ? _c('li', [_c('button', {
    staticClass: "btn btn-link btn-reply preventScrollToTop",
    attrs: {
      "disabled": _vm.bericht.userRole == 'B'
    },
    on: {
      "click": _vm.openReageerOpBericht
    }
  }, [_c('span', {
    staticClass: "icon clean"
  }, [_vm._v("r ")]), _vm._v(" Reageren\r\n                    ")])]) : _vm._e(), _vm._v(" "), (_vm.bericht.archief === true && _vm.bericht.verzonden === false) ? _c('li', [_c('button', {
    staticClass: "btn btn-link",
    attrs: {
      "disabled": _vm.bericht.userRole == 'B'
    },
    on: {
      "click": function($event) {
        return _vm.setUpdate(_vm.bericht.id, _vm.bericht.type, 'uitarchief');
      }
    }
  }, [_c('span', {
    staticClass: "icon clean"
  }, [_vm._v("o ")]), _vm._v(" Plaats terug in Inbox\r\n\t\t\t\t\t")])]) : _vm._e(), _vm._v(" "), (_vm.bericht.archief === false && _vm.bericht.verzonden === false) ? _c('li', [_c('button', {
    staticClass: "btn btn-link",
    attrs: {
      "disabled": _vm.bericht.userRole == 'B'
    },
    on: {
      "click": function($event) {
        return _vm.setUpdate(_vm.bericht.id, _vm.bericht.type, 'archief');
      }
    }
  }, [_c('span', {
    staticClass: "icon clean"
  }, [_vm._v("a ")]), _vm._v(" Archiveren\r\n\t\t\t\t\t")])]) : _vm._e()]), _vm._v(" "), (_vm.bericht.replyOpen === true) ? _c('div', {
    staticClass: "reply"
  }, [(_vm.replyIframeLoaded == false) ? _c('loader-component') : _vm._e(), _vm._v(" "), _c('iframe', {
    staticClass: "white-bg formframe",
    attrs: {
      "id": _vm.reageeriframeid,
      "name": "reageeriframe",
      "src": ""
    },
    on: {
      "load": function($event) {
        return _vm.handleOnLoad()
      }
    }
  })], 1) : _vm._e()])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1ae59d74"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/main/frontend/components/berichten/bericht.vue
// module id = 117
// module chunks = 0